var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrescriptionReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8535 5.14648L16.8535 0.146484C16.7598 0.0527344 16.6328 0 16.5 0H2C0.897461 0 0 0.896973 0 2V20C0 21.103 0.897461 22 2 22H20C21.1025 22 22 21.103 22 20V5.5C22 5.36719 21.9473 5.24023 21.8535 5.14648ZM17 1.70703L20.293 5H18C17.4482 5 17 4.55127 17 4V1.70703ZM20 21H2C1.44824 21 1 20.5513 1 20V2C1 1.44873 1.44824 1 2 1H16V4C16 5.10303 16.8975 6 18 6H21V20C21 20.5513 20.5518 21 20 21Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4395 10.9893H15.4395C15.2227 10.9893 15.0303 11.1289 14.9639 11.3354L14.4531 12.9126L11.9131 5.33057C11.8428 5.11914 11.6387 4.97119 11.4199 4.98975C11.1982 4.99854 11.0078 5.15234 10.9541 5.36816L8.37109 15.7021L6.91406 11.3311C6.8457 11.127 6.6543 10.9893 6.43945 10.9893H3.43945C3.16309 10.9893 2.93945 11.2129 2.93945 11.4893C2.93945 11.7656 3.16309 11.9893 3.43945 11.9893H6.0791L7.96484 17.6475C8.0332 17.8521 8.22461 17.9893 8.43945 17.9893C8.44531 17.9893 8.45215 17.9893 8.45898 17.9888C8.68066 17.9805 8.87109 17.8262 8.9248 17.6104L11.5088 7.27197L13.9873 14.6694C14.0547 14.8735 14.2461 15.0107 14.4609 15.0107H14.4639C14.6797 15.0098 14.8701 14.8701 14.9365 14.6646L15.8027 11.9893H18.4395C18.7158 11.9893 18.9395 11.7656 18.9395 11.4893C18.9395 11.2129 18.7158 10.9893 18.4395 10.9893Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionReportIcon);
export default __webpack_public_path__ + "static/media/PrescriptionReportIcon.4d256053651481076615f57c9bc57105.svg";
export { ForwardRef as ReactComponent };